import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
import { ContactoClienteList } from "../../contactos/list";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.DireccionClienteDTO;

const DireccionColoniaComp = obtenerComponenteDireccionColonia<Entity>("IdColonia", "Direccion", "Dirección");

export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un DireccionCliente
*/
export class DireccionClienteEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            IdColonia: validation.required,
            Direccion: x => !!(x.Direccion && x.Direccion.Calle && x.Direccion.NoExterior && x.Direccion.Telefono ) || "requerido"
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Contactos = getField(ContactoClienteList);

        const Text = getField(kea.Text);
        const CpSatMunicipioSelector = getField(CpSatMunicipioSelector2);
        const CpSatLocalidadSelector = getField(CpSatLocalidadSelector2);
        const CpSatColoniaSelector = getField(CpSatColoniaSelector2);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={validation.hasError(this.errors())} />]}
                onClose={this.onCerrar}
                title="Editar dirección"
            >
                <DireccionColoniaComp value={value} onChange={this.props.onChange} />

                <Contactos field="Contactos" idDireccion={value.IdRegistro} />
            </kea.Modal>
        )
    }
}

export const CpSatMunicipioSelector2 = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatMunicipioQuery, {}), 
x => x.IdRegistro, x => ( x.ClaveEstado + " - " + x.Descripcion ));

export const CpSatLocalidadSelector2 = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatLocalidadQuery, {}), 
x => x.IdRegistro, x => ( x.ClaveEstado + " - " + x.Descripcion ));

export const CpSatColoniaSelector2 = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatColoniaQuery, {}), 
x => x.IdRegistro, x => ( x.CodigoPostal + " - " + x.Nombre ));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/direcciones/edit.tsx